export enum ETipoLancamentoBaixa {
  Normal = 1,
  Acrescimos = 2,
  JurosMulta = 3,
  Credito = 4,
  Desconto = 5,
  Carteira = 6,
  Repasse =7,
}
